module.exports = __webpack_public_path__ + "static/Solution_Ad5-001957d30c1ac39d6b50bd9766b33fa0.png";